function easeInOutQuad(t: number, b: number, c: number, d: number): number {
	t /= d / 2;
	if (t < 1) {
		return (c / 2) * t * t + b;
	}
	t--;
	return (-c / 2) * (t * (t - 2) - 1) + b;
}

export function animatedWindowScroll(axis = "x", to = 0, duration = 1000) {
	const start = axis === "x" ? window.pageXOffset : window.pageYOffset;
	const staticAxisOffset = axis === "y" ? window.pageXOffset : window.pageYOffset;
	const change = to - start;
	const increment = 20;
	let currentTime = 0;

	const animateScroll = () => {
		currentTime += increment;
		const val = easeInOutQuad(currentTime, start, change, duration);
		if (axis === "x") {
			window.scroll(val, staticAxisOffset);
		} else {
			window.scroll(staticAxisOffset, val);
		}
		if (currentTime < duration) {
			setTimeout(animateScroll, increment);
		}
	};

	animateScroll();
}
